<template>
  <q-popup-proxy ref="popupProxy">
    <q-banner class="popup-wrapper">
      <div class="popup-wrapper__header">
        <p class="popup-wrapper__title">
          {{ this.title || 'Подтвердите действие' }}
        </p>
        <q-icon
          name="close"
          size="16px"
          class="popup-wrapper__close"
          @click="this.close()"
        />
      </div>
      <div class="popup-wrapper__actions">
        <q-btn
          size="sm"
          :disable="!!this.loading || this.localLoading"
          label="Отмена"
          @click="this.close()"
          class="popup-wrapper__cancel"
        />
        <q-btn
          size="sm"
          label="Подтвердить"
          :loading="!!this.loading || this.localLoading"
          :disable="!!this.loading || this.localLoading"
          @click="this.onClick()"
          class="popup-wrapper__confirm"
          :style="this.isDefault ? 'background-color: #0060fe' : 'background-color: #FF6C6C;'"
        />
      </div>
    </q-banner>
  </q-popup-proxy>
</template>

<script>
export default {
  name: "PopupConfirm",
  props: ["closePopup", "approve", "loading", "title", "isDefault"],
  data() {
    return {
      localLoading: false
    }
  },
  methods: {
    async onClick() {
      if (!this.approve) return
      this.localLoading = true
      await this.approve()
      this.localLoading = false
      this.close()
    },
    close() {
      try {
        this.$refs.popupProxy.hide();
        this.closePopup && this.closePopup()
      } catch (e) { }
    }
  }
}
</script>

<style scoped lang="scss">
.popup-wrapper {
  border-radius: 8px;
  padding: 16px;
  min-width: 280px;

  p {
    margin-bottom: 0;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
  }

  &__close {
    cursor: pointer;
    color: #000;
    border: none;
  }

  &__actions {
    margin-top: 20px;
    display: flex;
    align-items: center;
    gap: 16px;

    & > button {
      padding: 10px 8px;

      &::before {
      box-shadow: none !important;
    }
    }
  }

  &__cancel {
    flex: 0 0 48%;
    background-color: #fff;
    color: #0060FE;
    border: 1px solid #0060FE;
  }

  &__confirm {
    flex: 0 0 48%;
    background-color: #FF6C6C;
    color: #fff;
    border: none;
  }
}
</style>
